import type * as React from 'react';
import { post } from '@Domain/Api';
import connectionTested, {
	type ConnectionTestPayload,
	type ConnectionTestedAction,
} from '@Application/Security/Sso/Actions/connectionTested';
import connectionTestFailed, {
	type ConnectionTestFailedAction,
} from '@Application/Security/Sso/Actions/connectionTestFailed';
import type TestIdentityProviderConnection from '@Application/Security/Sso/Commands/TestIdentityProviderConnection';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = ConnectionTestedAction | ConnectionTestFailedAction;

export default (command: TestIdentityProviderConnection) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<ConnectionTestPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/identity-provider/connection-tests`,
				{},
			);

			const action = connectionTested(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = connectionTestFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
